module.exports = __webpack_public_path__ + "img/calendar-pin.626780c3.svg";